import * as React from 'react';
import { CheckCircle } from 'lucide-react';

export type TransferOutMethodOptionProps = {
  selected: boolean;
  onSelect: () => void;
  icon: React.ReactNode;
  primaryText: string;
  secondaryText: string;
  showSelectedCheck?: boolean;
};

export function TransferOutMethodOption({
  selected,
  onSelect,
  icon,
  primaryText,
  secondaryText,
  showSelectedCheck = true,
}: TransferOutMethodOptionProps) {
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onSelect}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect();
        }
      }}
      className={`p-4 border rounded-lg cursor-pointer transition-all ${
        selected
          ? 'border-primary bg-primary/5 ring-2 ring-primary/20'
          : 'border-border hover:border-primary/50'
      }`}
    >
      <div className="flex items-center space-x-3">
        {icon}
        <div className="flex-1 min-w-0">
          <div className="font-medium truncate">{primaryText}</div>
          <div className="text-sm text-muted-foreground">{secondaryText}</div>
        </div>
        {selected && showSelectedCheck && <CheckCircle className="w-5 h-5 text-primary shrink-0" />}
      </div>
    </div>
  );
}
